import React from 'react';
import PropTypes from 'prop-types';
import { observer, inject } from 'mobx-react';
import { Switch } from 'react-router-dom';

import PrivateRoute from '../components/core/PrivateRoute';
import authenticatedRoutes from '../authenticatedRoutes';

const AuthenticatedRouteContainer = ({ match, userStore }) => {
  const { user, isAuthenticated, blockedByPayment } = userStore;
  const { gtag } = window;

  if (gtag) {
    gtag('config', 'G-HGWRZTGYH7', {
      page_location: window.location.href,
      page_path: window.location.pathname,
    });
  }

  return (
    <section className="h-full">
      <Switch>
        {authenticatedRoutes.map((route) => (
          <PrivateRoute
            path={`${match.path}${route.path}`}
            component={route.component}
            isAuthenticated={isAuthenticated}
            blockedByPayment={blockedByPayment}
            userProfile={user}
            key={route.path}
          />
        ))}
      </Switch>
    </section>
  );
};

AuthenticatedRouteContainer.propTypes = {
  match: PropTypes.shape({
    path: PropTypes.string.isRequired,
  }).isRequired,
  userStore: PropTypes.shape({
    user: PropTypes.shape({
      username: PropTypes.string,
      customer: PropTypes.shape({
        stripeEnabled: PropTypes.bool,
        stripePaid: PropTypes.bool,
      }),
    }),
    isAuthenticated: PropTypes.bool.isRequired,
  }).isRequired,
  notificationsStore: PropTypes.shape({
    notifications: PropTypes.oneOfType([
      PropTypes.arrayOf(PropTypes.shape({
        label: PropTypes.string,
        severity: PropTypes.string,
      })),
      PropTypes.object,
    ]).isRequired,
  }).isRequired,
};

export default inject('userStore', 'notificationsStore')(observer(AuthenticatedRouteContainer));
